export default "__VITE_ASSET__B_IoyF8L__"